"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  Browse: "参照",
  Change: "変更",
  "Drop your image here": "ここに画像をドロップ",
  "Drop your logo here": "ここにロゴをドロップ",
  Remove: "削除",
  "Revert to default": "既定値に戻す",
  "Sorry, \"{fileName}\" is larger than {maxFileSize} and can't be uploaded. Please upload a file that's {maxFileSize} or smaller.": ['"', ["fileName"], '" は ', ["maxFileSize"], " を超えているため、アップロードできません。 ", ["maxFileSize"], " 以下のファイルをアップロードしてください。"],
  "Sorry, \"{fileName}\" is smaller than {minFileSize} and can't be uploaded. Please upload a file that's {minFileSize} or larger.": ['"', ["fileName"], '" は ', ["minFileSize"], " より小さいため、アップロードできません。 ", ["minFileSize"], " 以上のファイルをアップロードしてください。"],
  "Sorry, this image format isn't supported. Please provide a {fileTypes}.": ["申し訳ありません。この画像形式はサポートされていません。 ", ["fileTypes"], " 形式で提供してください。"],
  "Unsupported file type": "サポートされていないファイル形式です"
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map